// This file was generated and should not be edited
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var IconMediaMicrophoneOff_1;
import { html } from 'lit';
import { customElement } from 'lit/decorators.js';
import { IconBaseElement } from '../base/icon-base.component';
const _s16IconSvg = html `<svg viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path fill-rule="evenodd" clip-rule="evenodd" d="M13.3119 0L0.583984 12.7279L1.9982 14.1421L3.8281 12.3122C4.68092 13.1375 5.77781 13.712 7 13.917V16H9V13.917C11.8377 13.441 14 10.973 14 8V6L12 5V8C12 10.2091 10.2091 12 8 12C6.93112 12 5.96017 11.5808 5.2426 10.8977L5.95003 10.1903C6.48637 10.6925 7.20728 10.9999 8 10.9999C9.65684 10.9999 11 9.65683 11 8V5.14033L14.7261 1.41421L13.3119 0ZM9 7.14033L7.36653 8.7738C7.53901 8.91516 7.7596 9 8 9C8.55228 9 9 8.55228 9 8V7.14033Z" class="svg-bg"/>
  <path d="M3.50134 7 4 6.50134V5L2 6V8C2 8.16233 2.00645 8.32316 2.0191 8.48224L2.50134 8H2.5L3.5 7H3.50134ZM5 5.50134 7 3.50134V3.00005C7.00003 2.44778 7.44773 2.00005 8 2.00005 8.14708 2.00005 8.28675 2.0318 8.41252 2.08883L9.85738.643966C9.34653.240685 8.70137 0 8 0 6.34315 0 5 1.34315 5 3V5.50134Z" class="svg-bg"/>
</svg>
`;
const _s24IconSvg = html `<svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path fill-rule="evenodd" clip-rule="evenodd" d="M1.41431 21.2126L2.80844 22.6066L7.09457 18.3204C8.20102 19.1802 9.53916 19.756 10.9996 19.9381V24H12.9996V19.9381C16.9459 19.446 19.9996 16.0796 19.9996 12H17.9996C17.9996 15.3137 15.3133 18 11.9996 18C10.7039 18 9.50449 17.5894 8.52377 16.8912L9.96835 15.4467C10.5638 15.7983 11.2581 16 11.9996 16C14.2088 16 15.9996 14.2092 15.9996 12V9.41534L22.6073 2.80762L21.1932 1.39337L21.2128 1.41405L1.41431 21.2126ZM11.4825 13.9325L13.9996 11.4153V12C13.9996 13.1046 13.1041 14 11.9996 14C11.8209 14 11.6476 13.9765 11.4825 13.9325Z" class="svg-bg"/>
  <path d="M15.9949 3.80357C15.8925 1.68564 14.143 0 11.9996 0 9.79038 0 7.9996 1.79083 7.9996 4V11.7988L9.9996 9.79883V4C9.9996 2.89545 10.8951 2 11.9996 2 13.1041 2 13.9996 2.89545 13.9996 4V5.79883L15.9949 3.80357ZM6.21163 13.5868C6.0734 13.0814 5.9996 12.5493 5.9996 12H3.9996C3.9996 13.1198 4.22963 14.1858 4.64506 15.1534L6.21163 13.5868Z" class="svg-bg"/>
</svg>
`;
/**
 * IconMediaMicrophoneOff is a generated icon component.
 */
let IconMediaMicrophoneOff = IconMediaMicrophoneOff_1 = class IconMediaMicrophoneOff extends IconBaseElement {
    render() {
        return html `${IconMediaMicrophoneOff_1.icons.get(this.size)}`;
    }
};
/**
   * Defines which icon resource to use at which icon size
   */
IconMediaMicrophoneOff.icons = new Map([
    ['s8', _s16IconSvg],
    ['s12', _s16IconSvg],
    ['s16', _s16IconSvg],
    ['s24', _s24IconSvg],
    ['s32', _s24IconSvg],
    ['s40', _s24IconSvg],
    ['s48', _s24IconSvg],
    ['s64', _s24IconSvg],
    ['s72', _s24IconSvg],
    ['s80', _s24IconSvg],
]);
IconMediaMicrophoneOff = IconMediaMicrophoneOff_1 = __decorate([
    customElement('zui-icon-media-microphone-off')
], IconMediaMicrophoneOff);
export { IconMediaMicrophoneOff };
